import { render, staticRenderFns } from "./LeadComments.vue?vue&type=template&id=475fed17&scoped=true"
import script from "./LeadComments.vue?vue&type=script&lang=js"
export * from "./LeadComments.vue?vue&type=script&lang=js"
import style0 from "./LeadComments.vue?vue&type=style&index=0&id=475fed17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475fed17",
  null
  
)

export default component.exports